<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <header class="card-header">
            <strong>Permissões PMAU</strong>
          </header>
          <div class="card-body">
            <!-- Filtros: a lista só carrega ao clicar em Buscar. -->
            <div class="perm-filters mb-4">
              <div class="row">
                <div class="col-md-3 mb-2">
                  <label class="perm-label">Conta</label>
                  <b-form-select v-model="filtro.conta_id" :options="contaOptions" size="sm"></b-form-select>
                </div>
                <div class="col-md-3 mb-2">
                  <label class="perm-label">Usuário</label>
                  <b-form-input
                    v-model="filtro.busca"
                    size="sm"
                    placeholder="Nome ou e-mail"
                    @keyup.enter="Buscar"
                  ></b-form-input>
                </div>
                <div class="col-md-2 mb-2">
                  <label class="perm-label">Módulo</label>
                  <b-form-select v-model="filtro.module" :options="moduloOptions" size="sm"></b-form-select>
                </div>
                <div class="col-md-2 mb-2">
                  <label class="perm-label">Permissão</label>
                  <b-form-select v-model="filtro.active" :options="situacaoOptions" size="sm"></b-form-select>
                </div>
                <div class="col-md-2 mb-2 d-flex align-items-end">
                  <button class="btn btn-sm btn-success btn-block" :disabled="loading || loadingOptions" @click="Buscar">
                    <i class="fa fa-search mr-1"></i> Buscar
                  </button>
                </div>
              </div>
            </div>

            <div v-if="loading" class="loading-container">
              <RotateSquare size="60px" class="loading-position animated fadeIn"></RotateSquare>
            </div>

            <p v-else-if="!buscou" class="text-muted text-center py-4 mb-0">
              Escolha os filtros e clique em Buscar.
            </p>

            <div v-else>
              <table class="table table-hover mb-0 perm-table">
                <thead>
                  <tr>
                    <th class="perm-fit">Usuário</th>
                    <th v-if="mostrarConta" class="perm-fit">Conta</th>
                    <th v-for="mod in modules" :key="mod.code" class="text-center perm-fit">
                      {{ mod.name }}
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="linhas.length === 0">
                    <td :colspan="modules.length + (mostrarConta ? 3 : 2)" class="text-center text-muted py-4">
                      Nenhum usuário encontrado.
                    </td>
                  </tr>
                  <tr v-for="row in linhas" :key="row.conta_id + row.usuario_id">
                    <td class="perm-fit">
                      <div class="font-weight-bold">
                        {{ row.nome }}
                        <span v-if="row.pmau_admin" class="perm-admin-tag ml-1">Admin PMAU</span>
                      </div>
                      <small class="text-muted">{{ row.email }}</small>
                    </td>
                    <td v-if="mostrarConta" class="align-middle perm-fit">{{ row.conta_nome }}</td>
                    <td v-for="mod in modules" :key="mod.code" class="text-center align-middle">
                      <b-form-checkbox
                        :checked="row.modules.includes(mod.code)"
                        switch
                        class="perm-switch"
                        :disabled="row.pmau_admin || salvando === row.conta_id + row.usuario_id"
                        @change="Alternar(row, mod.code, $event)"
                      ></b-form-checkbox>
                    </td>
                    <td class="text-right text-nowrap align-middle">
                      <template v-if="!row.pmau_admin">
                        <button
                          v-for="preset in presets"
                          :key="preset.label"
                          class="btn btn-sm btn-link px-1"
                          :disabled="salvando === row.conta_id + row.usuario_id"
                          @click="Salvar(row, preset.modules())"
                        >
                          {{ preset.label }}
                        </button>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import PmauService from "../../servico/PmauService";

export default {
  name: "PmauPermissoes",
  components: { RotateSquare },
  data() {
    return {
      loadingOptions: false,
      loading: false,
      buscou: false,
      salvando: null,
      contas: [],
      modules: [],
      filtro: { conta_id: null, busca: "", module: null, active: null },
      contaBuscada: null,
      linhas: [],
      presets: [
        { label: "Tudo", modules: () => this.modules.map(m => m.code) },
        { label: "Só resultado", modules: () => ["resultado"] },
        { label: "Nenhum", modules: () => [] }
      ]
    };
  },
  computed: {
    contaOptions() {
      return [{ value: null, text: "Todas as minhas contas" }].concat(
        this.contas.map(c => ({
          value: c.conta_id,
          text: c.nome + (c.pmau_habilitado ? "" : " (PMAU desligado)")
        }))
      );
    },
    moduloOptions() {
      return [{ value: null, text: "Qualquer módulo" }].concat(
        this.modules.map(m => ({ value: m.code, text: m.name }))
      );
    },
    situacaoOptions() {
      return [
        { value: null, text: "Todas" },
        { value: true, text: "Com acesso" },
        { value: false, text: "Sem acesso" }
      ];
    },
    mostrarConta() {
      return !this.contaBuscada && this.contas.length > 1;
    }
  },
  async beforeMount() {
    this.loadingOptions = true;
    try {
      var res = await PmauService.GetPmauPermissionOptions();
      this.contas = res.data.contas;
      this.modules = res.data.modules;
      var auth = this.$store.getters.getAutenticacao;
      var atual = auth && auth.contaSelecionada ? auth.contaSelecionada.id : null;
      if (this.contas.some(c => c.conta_id === atual)) this.filtro.conta_id = atual;
    } catch (e) {
      this.$notify({ data: ["Erro ao carregar os filtros."], type: "error" });
    } finally {
      this.loadingOptions = false;
    }
  },
  methods: {
    async Buscar() {
      this.loading = true;
      var params = {};
      Object.keys(this.filtro).forEach(k => {
        var v = typeof this.filtro[k] === "string" ? this.filtro[k].trim() : this.filtro[k];
        if (v !== null && v !== "") params[k] = v;
      });
      try {
        var res = await PmauService.SearchPmauPermissions(params);
        this.linhas = res.data;
        this.contaBuscada = this.filtro.conta_id;
        this.buscou = true;
      } catch (e) {
        this.$notify({ data: ["Erro ao buscar os usuários."], type: "error" });
      } finally {
        this.loading = false;
      }
    },

    Alternar(row, code, ligado) {
      var set = new Set(row.modules);
      if (ligado) {
        set.add(code);
        if (code === "criar") set.add("resultado");
      } else {
        set.delete(code);
        // "Resultado" vem junto com "Criar PMAU": tirar o resultado tira o criar.
        if (code === "resultado") set.delete("criar");
      }
      this.Salvar(row, this.modules.map(m => m.code).filter(c => set.has(c)));
    },

    async Salvar(row, modules) {
      var anterior = row.modules;
      row.modules = modules;
      this.salvando = row.conta_id + row.usuario_id;
      try {
        var res = await PmauService.SetPmauUserPermissions(row.conta_id, row.usuario_id, modules);
        row.modules = res.data.modules;
        this.$notify({ data: ["Permissões de " + row.nome + " salvas."], type: "success" });
      } catch (e) {
        row.modules = anterior;
        this.$notify({
          data: [
            e.response && e.response.data && e.response.data.detail
              ? e.response.data.detail
              : "Erro ao salvar as permissões."
          ],
          type: "error"
        });
      } finally {
        this.salvando = null;
      }
    }
  }
};
</script>

<style scoped>
.perm-filters {
  background-color: #f7f8fa;
  border: 1px solid #e4e7eb;
  border-radius: 4px;
  padding: 0.75rem 1rem 0.25rem;
}
.perm-label {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}
.perm-table th {
  border-top: 0;
  font-size: 0.85rem;
  vertical-align: bottom;
}
/* Tabela do tamanho do conteúdo (colunas sem sobra); se não couber, o texto quebra linha
   em vez de gerar scroll horizontal. */
.perm-table {
  width: auto;
  max-width: 100%;
}
.perm-switch {
  display: inline-block;
}
/* Mão ao passar o mouse nos switches (o label do custom-switch é a área clicável). */
.perm-switch ::v-deep .custom-control-label,
.perm-switch ::v-deep .custom-control-input {
  cursor: pointer;
}
.perm-switch ::v-deep .custom-control-input:disabled ~ .custom-control-label {
  cursor: not-allowed;
}
.perm-admin-tag {
  color: #2f7d32;
  font-size: 0.75rem;
  font-weight: 600;
}
</style>
